/* global __DEV__ */
// import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'


const queryClient = new QueryClient()


import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { store, initLocalization } from '@front/store'
import Router from './router'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { SafeAreaProvider, initialWindowMetrics } from 'react-native-safe-area-context'
import ThemeProvider from './provider.theme'
import { Host } from 'react-native-portalize'
import FullScreenContainer from './components/fullscreencontainer'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { FormDevtoolsPlugin } from '@tanstack/react-form-devtools'

initLocalization(__DEV__)

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <SafeAreaProvider initialMetrics={initialWindowMetrics}>
          <ThemeProvider>
            <Host>
              <FullScreenContainer>
                <BrowserRouter>
                  <Router />
                </BrowserRouter>
                {/* <TanStackDevtools plugins={[FormDevtoolsPlugin()]} /> */}
              </FullScreenContainer>
            </Host>
          </ThemeProvider>
        </SafeAreaProvider>
      </QueryClientProvider>
    </Provider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <App />
)

